import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  &.disabled .trash-can {
    fill: ${({ theme }) => theme.colors.text04}
  }
  &.selected .trash-can {
    fill: ${({ theme }) => theme.colors.errorRed01}
  }
`;

export const Delete = (props) => (
  <SVG {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      className="trash-can"
      d="M3.91875 0.414609C4.04531 0.1605 4.30547 0 4.58906 0H7.41094C7.69453 0 7.95469 0.1605 8.08125 0.414609L8.25 0.75H10.5C10.9148 0.75 11.25 1.08586 11.25 1.5C11.25 1.91414 10.9148 2.25 10.5 2.25H1.5C1.08586 2.25 0.75 1.91414 0.75 1.5C0.75 1.08586 1.08586 0.75 1.5 0.75H3.75L3.91875 0.414609ZM1.47891 3H10.5V10.5C10.5 11.3273 9.82734 12 9 12H2.97891C2.17148 12 1.47891 11.3273 1.47891 10.5V3ZM3.35391 4.875V10.125C3.35391 10.3313 3.54375 10.5 3.72891 10.5C3.95625 10.5 4.10391 10.3313 4.10391 10.125V4.875C4.10391 4.66875 3.95625 4.5 3.72891 4.5C3.54375 4.5 3.35391 4.66875 3.35391 4.875ZM5.60391 4.875V10.125C5.60391 10.3313 5.79375 10.5 5.97891 10.5C6.20625 10.5 6.375 10.3313 6.375 10.125V4.875C6.375 4.66875 6.20625 4.5 5.97891 4.5C5.79375 4.5 5.60391 4.66875 5.60391 4.875ZM7.875 4.875V10.125C7.875 10.3313 8.04375 10.5 8.25 10.5C8.45625 10.5 8.625 10.3313 8.625 10.125V4.875C8.625 4.66875 8.45625 4.5 8.25 4.5C8.04375 4.5 7.875 4.66875 7.875 4.875Z"
      fill="#000"
    />
  </SVG>
);
